import { Injectable } from "@angular/core";
import { UserServiceBackend } from "@serviceBackend";
import { UserDTO } from "@shared/dtos";
import { firstValueFrom, map, Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private userServiceBackend: UserServiceBackend) { }
    
    public async getUser(idUser: string) {
        const users = await firstValueFrom(this.userServiceBackend.getUser(idUser));       

        return users;
    }
    
    public createUser(user: UserDTO) {
        return this.userServiceBackend.saveUser(user);
    }
}